import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "worldWithMachine",
    iconColor: "white",
    text: "Cluster the jobs into the \nneighboring wire centers with \ntheconstraint of driving distance",
    listItemCustomStyle: { width: "400px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "circlesConnected",
    iconColor: "white",
    text: "Enable grouping of nearby \nwirecenter(s) without any \ntech to nearby wirecenter(s) \nwith tech",
    listItemCustomStyle: { width: "368px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "cloudWithCircuits",
    iconColor: "white",
    text: "Group nearby wirecenters \nto form service areas",
    listItemCustomStyle: { width: "322px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_BENEFITS_TO_1 = {
  title: "Optimize areas boundaries",
  titleNumber: "1.",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "topaz.png",
  text: "Precision Service Area Optimization: Define service area boundaries \nstrategically by grouping wire centers, effectively reducing both \noverutilization and underutilization of technicians. Achieve an optimized \ndistribution of workload for enhanced job completion rate and optimal \nrouting.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "NEXT",
    onClick: () => setCurrentPage(403),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(401),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "TURF_OPTIMIZATION/TO_bg_2.png",
};
